// The API answers a well-formed id that matches no published show with a
// GraphQL error under the generic `INTERNAL_SERVER_ERROR` code, so the message
// is all that tells a missing show from a backend failure. Matching on prose
// is fragile, but it fails safe: reworded, the player goes back to the error
// screen and Sentry back to reporting — exactly what happened before. Switch
// to `extensions.code` the day the API exposes a dedicated one.
export const isShowNotFound = ({ message }: { message: string }): boolean =>
  message === "Show not found";
